/*global GridController*/

var TrackedMailEventEmbeddable = function(options){    
    GridController.call(this,"iz_tracked_mail_event", 
    {
        directory: "views/tracked",
        name: "trackedMailEventGrid"
    }) ;

    /**
     * This is called when the embeddable is loaded with data (typically a view render)
     * 
     * @param {object} data the data given to the embedded instance (for example : the customer)
    */
    this.prepareDataOnEnter = function(data, callback){
        if(data && options && options.searchfield){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions = {} ;
            this.searchOptions[options.searchfield] = data.id ;
        }
        //CNIL compliance (issue #5326): opening events (tracking pixel, Apple Mail proxy) and link
        //clicks are still stored but never displayed, their date would reveal when the recipient
        //read the mail. The receipt itself is shown by the mail state ("Receipt confirmed")
        this.searchOptions = this.searchOptions || {} ;
        this.searchOptions.event = {ope: "not in", value: ["opened", "loadedByProxy", "proxy_open", "click", "clicks"]} ;
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;
} ;

TrackedMailEventEmbeddable.prototype = Object.create(GridController.prototype);
TrackedMailEventEmbeddable.prototype.constructor = TrackedMailEventEmbeddable;

module.exports = TrackedMailEventEmbeddable ;